import React from "react";
import api from "./../../Api.js";
import moment from "moment";
import classnames from "classnames";
import { connect } from "react-redux";
import InputMask from "react-input-mask";
import {
  Container,
  Row,
  Card,
  CardHeader,
  Col,
  Button,
  Table,
  UncontrolledTooltip,
  Tooltip,
} from "reactstrap";
import NotificationAlert from "react-notification-alert";
import SimpleHeader from "./../../components/Headers/SimpleHeader.jsx";
import { Link } from "react-router-dom";
import { ClipLoader } from "react-spinners";

import ImportXlsxClassRoom from "./modal/ImportXlsxClassRoom.jsx";
import TransferModal from "./listClssroom/TransferModal.jsx";
import ClassRoomCreateModal from "./listClssroom/ClassRoomCreateModal.jsx";
import ParticipantsManageModal from "./listClssroom/ParticipantsManageModal.jsx";
import SettingsModal from "./listClssroom/SettingsModal.jsx";
import RemoveClassRoomModal from "./listClssroom/RemoveClassRoomModal.jsx";

require("moment/locale/pt-br");
require("moment/locale/en-au");
require("moment/locale/es");

class ListClassRoom extends React.Component {
  constructor(props) {
    super(props);
    this.courseUnitsCountCache = new Map();
    this.courseUnitsRequestCache = new Map();
    this.state = {
      openModalImportClassRoom: false,
      loadClassroom: false,
      classRooms: [],
      course: [],
      loadCourse: false,
      addUserClassRoomModal: false,
      company:
        (this.props.user && this.props.user.preference
          ? this.props.user.preference.selectcompany
          : "") || "",
      showRest: false,
      searchTimeout: null,
      settingsModalOpen: false,
      settingsTarget: null,
      searchClassroomText: "",
      searchClassroomTimeout: null,
      participantsTarget: null,
      tooltipOpen: false,
      tooltipTarget: null,
      tooltipData: null,
      classRoomEditor: null,
      openModalTransfer: false,
      removalTarget: null,
    };

    this.getAllClassRoom = this.getAllClassRoom.bind(this);
    this.filterClassRoom = this.filterClassRoom.bind(this);
    this.addUserClassRoom = this.addUserClassRoom.bind(this);
    this.deleteClassRoom = this.deleteClassRoom.bind(this);
    this.newImport = this.newImport.bind(this);
    this.getClassRooms = this.getClassRooms.bind(this);
    this.openGeneralSettings = this.openGeneralSettings.bind(this);
    this.closeGeneralSettings = this.closeGeneralSettings.bind(this);
  }

  showTooltip = (targetId, data) => {
    try {
      const el = document.getElementById(targetId);
      if (!el) return;
    } catch (e) {
      return;
    }
    this.setState({ tooltipTarget: targetId, tooltipData: data, tooltipOpen: true });
  };

  hideTooltip = () => {
    this.setState({ tooltipOpen: false, tooltipTarget: null, tooltipData: null });
  };

  openModal = (modalKey, extraState = {}) => {
    if (!modalKey) {
      return;
    }
    this.setState({ ...extraState, [modalKey]: true });
  };

  closeModal = (modalKey, extraState = {}) => {
    if (!modalKey) {
      return;
    }
    this.setState({ ...extraState, [modalKey]: false });
  };

  componentDidMount = async () => {
    await this.getAllCourses();
    await this.getClassRooms(this.props.user?.preference?.selectcompany);
    this.setState({ loadComplete: true });
  };

  async componentDidUpdate(prevProps) {
    const previousCompany = prevProps.user?.preference?.selectcompany || "";
    const currentCompany = this.props.user?.preference?.selectcompany || "";

    if (previousCompany !== currentCompany) {
      await this.getClassRooms(currentCompany);
      this.setState({ loadComplete: true });
    }
  }

  componentWillUnmount() {
    if (this.state.searchClassroomTimeout) {
      clearTimeout(this.state.searchClassroomTimeout);
    }
  }



  getUnitsCountForCourse = async (courseId) => {
    const key = courseId != null ? String(courseId) : "";
    if (!key) {
      return 0;
    }

    if (this.courseUnitsCountCache.has(key)) {
      return this.courseUnitsCountCache.get(key);
    }

    if (this.courseUnitsRequestCache.has(key)) {
      return this.courseUnitsRequestCache.get(key);
    }

    const request = api
      .getUnitsCourse(courseId)
      .then((res) => {
        const count = Array.isArray(res?.data) ? res.data.length : 0;
        this.courseUnitsCountCache.set(key, count);
        this.courseUnitsRequestCache.delete(key);
        return count;
      })
      .catch((error) => {
        console.error("Erro ao carregar units do curso", courseId, error);
        this.courseUnitsCountCache.set(key, 0);
        this.courseUnitsRequestCache.delete(key);
        return 0;
      });

    this.courseUnitsRequestCache.set(key, request);
    return request;
  };

  newImport() {
    this.openModal("openModalImportClassRoom");
  }

  // Carrega todas as turmas, com contagens
  async getAllClassRoom(
    companyId = this.props.user?.preference?.selectcompany || "",
    options = {}
  ) {
    if (!companyId) {
      this.setState({ classRooms: [], loadClassroom: true });
      return;
    }

    try {
      const response = await api.getAllClassRoomCompanyWithCounts(companyId);
      if (response && Array.isArray(response.data)) {
        const raw = response.data.slice().reverse();
        const classRooms = await Promise.all(
          raw.map(async (cr) => {
            const unitsCount = await this.getUnitsCountForCourse(cr.course);
            return {
              ...cr,
              unitsCount,
              countStudents: cr.countStudents || 0,
              countTeachers: cr.countTeachers || 0,
              countAdmins: cr.countAdmins || 0,
              countParticipants: cr.countParticipants || 0,
              countActive: cr.countActive || 0,
              countInactive: cr.countInactive || 0,
            };
          })
        );
        this.filterClassRoom(classRooms);
        this.setState({ loadClassroom: true });
      } else {
        this.setState({ classRooms: [], loadClassroom: true });
      }
    } catch (error) {
      console.error(error);
      if (error.response?.status === 401) {
        this.refs.notificationAlert.notificationAlert({
          place: "tr",
          message: (
            <div className="alert-text">
              <span className="alert-title" data-notify="title">
                Ops!
              </span>
              <span data-notify="message">{error.response.data.msg}</span>
            </div>
          ),
          type: "danger",
          icon: "fas fa-exclamation",
          autoDismiss: 7,
        });
      }
      this.setState({ loadClassroom: true });
    }
  }

  // Carrega apenas turmas em que o usuário está envolvido
  async myclassroom() {
    try {
      const res = await api.getMyClassRooms();
      const reversed = res.data.reverse();
      this.filterClassRoom(reversed);
    } catch (error) {
      console.error(error);
      if (error.response?.status === 401) {
        this.refs.notificationAlert.notificationAlert({
          place: "tr",
          message: (
            <div className="alert-text">
              <span className="alert-title" data-notify="title">
                {this.props.translate["ops"]}!
              </span>
              <span data-notify="message">{error.response.data.msg}</span>
            </div>
          ),
          type: "danger",
          icon: "fas fa-exclamation",
          autoDismiss: 7,
        });
      }
    }
  }

  // Carrega todos os cursos
  async getAllCourses() {
    try {
      const res = await api.getAllcourses();
      const arr = Array.isArray(res.data) ? res.data : [];
      const seen = new Set();
      const unique = [];
      for (const c of arr) {
        const idStr = String(c.id);
        if (seen.has(idStr)) continue;
        seen.add(idStr);
        unique.push(c);
      }
      this.setState({ course: unique, loadCourse: true });
    } catch (error) {
      console.error(error);
    }
  }

  // Adiciona nome do curso em cada turma
  filterClassRoom(array) {
    const { course } = this.state;
    const enriched = array.map((cr) => {
      const matchCurso = course.find((c) => c.id === cr.course);
      return {
        ...cr,
        courseName: matchCurso ? matchCurso.name : "",
      };
    });
    this.setState({ classRooms: enriched, loadClassroom: true });
  }

  newClassRoom = () => {
    this.setState({
      classRoomEditor: { mode: "create", classroom: null },
    });
  };

  editClassRoom = (id) => {
    const cr = this.state.classRooms.find((item) => item.id === id);
    if (!cr) {
      return;
    }
    this.setState({
      classRoomEditor: { mode: "edit", classroom: cr },
    });
  };

  postClassRoom = async (isImport = false, importPayload = {}) => {
    const basePayload = isImport ? { ...importPayload } : { ...importPayload };
    const selectedCompany =
      this.state.company || this.props.user?.preference?.selectcompany || "";

    if (!basePayload.company && selectedCompany) {
      basePayload.company = selectedCompany;
    }

    if (!basePayload.company) {
      return false;
    }

    try {
      const response = await api.postClassRoom(basePayload);
      return response?.data;
    } catch (error) {
      if (error?.response?.status === 400) {
        console.error("Erro ao importar turma", error.response.data?.msg);
      } else {
        console.error("Erro ao cadastrar turma", error);
      }
      return false;
    }
  };

  notify = (options = {}) => {
    if (this.refs.notificationAlert && options) {
      this.refs.notificationAlert.notificationAlert(options);
    }
  };

  handleClassRoomModalClose = () => {
    this.setState({ classRoomEditor: null });
  };

  handleClassRoomModalSaved = async ({ classroom, mode }) => {
    const companyId =
      this.state.company || this.props.user?.preference?.selectcompany || "";

    this.handleClassRoomModalClose();

    try {
      await this.getClassRooms(companyId);
    } catch (error) {
      console.error("Erro ao atualizar lista de turmas", error);
    }

    const isCreate = mode === "create";
    const title = this.props.translate["sucesso"] || "Sucesso";
    const message = isCreate
      ? this.props.translate["a_turma_foi_cadastrada_com_sucesso"] ||
      "A turma foi cadastrada com sucesso."
      : this.props.translate["alteracoes_salvas"] || "As alterações foram salvas.";

    this.notify({
      place: "tr",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}!
          </span>
          <span data-notify="message">{message}</span>
        </div>
      ),
      type: "success",
      icon: "ni ni-check-bold",
      autoDismiss: 7,
    });
  };

  handleRemoveModalClose = () => {
    this.setState({ removalTarget: null });
  };

  handleClassRoomRemoved = (removedId) => {
    this.setState((prevState) => ({
      classRooms: prevState.classRooms.filter((cr) => cr.id !== removedId),
      removalTarget: null,
    }));
  };

  deleteClassRoom(id) {
    const target = this.state.classRooms.find((item) => item.id === id);
    const fallback = target || { id };
    this.setState({ removalTarget: fallback });
  }

  returnKeys(obj) {

    if (!Array.isArray(obj) || obj.length === 0) {
      return [];
    }

    return obj.map((x) => ({
      key: x.id,
      name: (x.name || "") + " " + (x.lastName || ""),
      value: x.id,
    }));
  }

  async addUserClassRoom(id) {
    this.openModal("addUserClassRoomModal", { participantsTarget: id });
  }

  async getClassRooms(
    companyId = this.props.user?.preference?.selectcompany || "",
    options = {}
  ) {
    const effectiveCompany = companyId || "";

    this.setState({ company: effectiveCompany });

    const permissions = Array.isArray(this.props.permission)
      ? this.props.permission
      : [];

    if (permissions.indexOf(19) !== -1) {
      if (!effectiveCompany) {
        this.setState({ classRooms: [], loadClassroom: true });
        return;
      }
      await this.getAllClassRoom(effectiveCompany);
      return;
    }

    if (permissions.indexOf(24) !== -1) {
      await this.myclassroom();
      return;
    }

    this.setState({ classRooms: [], loadClassroom: true });
  }

  normalizeSelectValue = (val) => {
    if (val && typeof val === "object" && "value" in val)
      return String(val.value);
    return val != null ? String(val) : "";
  };

  openGeneralSettings(classroom) {
    this.openModal("settingsModalOpen", { settingsTarget: classroom });
  }

  closeGeneralSettings() {
    this.closeModal("settingsModalOpen", { settingsTarget: null });
  }


  render() {
    const {
      classRooms,
      loadClassroom,
      showRest,
    } = this.state;
    const permissions = Array.isArray(this.props.permission)
      ? this.props.permission
      : [];
    const selectedCompany =
      this.state.company || this.props.user?.preference?.selectcompany || "";
    const countTotal = classRooms.length;
    const filter = (this.state.searchClassroomText || "").toLowerCase().trim();
    const visibleClassrooms = !filter
      ? classRooms
      : classRooms.filter(
        (cr) =>
          (cr.name || "").toLowerCase().includes(filter) ||
          String(cr.id).includes(filter) ||
          (cr.courseName || "").toLowerCase().includes(filter)
      );

    return (
      <React.Fragment>
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>
        <SimpleHeader
          name={this.props.translate["turmas"]}
          way={[{ name: this.props.translate["turmas"], url: "/classroom" }]}
        />
        <Container className="mt--6" fluid>
          <Row>
            <div className="col">
              <Card>
                <CardHeader>
                  <Row>
                    <Col xs="6">
                      <h3 className="mb-0">
                        {this.props.translate["turmas"]}
                        {loadClassroom && (
                          <span
                            className="ml-2 text-muted"
                            style={{ fontSize: "1rem" }}
                          >
                            ({countTotal})
                          </span>
                        )}
                      </h3>
                    </Col>
                    <Col xs="6" className="text-right">
                      {permissions.indexOf(14) !== -1 &&
                        selectedCompany !== "" && (
                          <React.Fragment>
                            <Button
                              className="btn-round btn-icon"
                              color="success"
                              size="sm"
                              onClick={this.newImport}
                            >
                              <span className="btn-inner--icon mr-1">
                                <i className="far fa-file-excel" />
                              </span>
                              <span className="btn-inner--text">
                                {this.props.translate["importar_planilha"]}
                              </span>
                            </Button>
                            <Button
                              className="btn-neutral btn-round btn-icon"
                              color="default"
                              size="sm"
                              onClick={this.newClassRoom}
                            >
                              <span className="btn-inner--icon mr-1">
                                <i className="fas fa-plus" />
                              </span>
                              <span className="btn-inner--text">
                                {this.props.translate["criar_turma"]}
                              </span>
                            </Button>
                          </React.Fragment>
                        )}
                    </Col>
                  </Row>
                </CardHeader>

                <div>
                  <div
                    style={{ marginTop: "10px" }}
                    className="dataTables_filter px-4 pb-1"
                  >
                    <label>
                      {this.props.translate["procurar"]}:
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        onChange={(e) => {
                          const val = e.target.value;
                          if (this.state.searchClassroomTimeout)
                            clearTimeout(this.state.searchClassroomTimeout);
                          const t = setTimeout(
                            () => this.setState({ searchClassroomText: val }),
                            200
                          );
                          this.setState({ searchClassroomTimeout: t });
                        }}
                      />
                    </label>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div>
                      <input
                        type="checkbox"
                        className="form-control"
                        checked={showRest}
                        onChange={(e) =>
                          this.setState({ showRest: e.target.checked })
                        }
                      />
                    </div>
                    <div style={{ marginLeft: "10px" }}>
                      {this.props.translate["mostrar_outras_informacoes"]}
                    </div>
                  </div>
                </div>

                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th>id</th>
                      <th>{this.props.translate["nome"]}</th>
                      <th>{this.props.translate["curso"]}</th>
                      <th hidden={!showRest}>
                        {this.props.translate["id_online"]}
                      </th>
                      <th hidden={!showRest}>
                        <center>
                          {this.props.translate["data_de_abertura"]}
                        </center>
                      </th>
                      <th hidden={!showRest}>
                        <center>
                          {this.props.translate["data_de_fechamento"]}
                        </center>
                      </th>
                      <th>
                        <center>{this.props.translate["participantes"]}</center>
                      </th>
                      <th className="text-center">
                        {this.props.translate["acoes"]}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {visibleClassrooms.map((value) => {
                      let permits;
                      if (permissions.indexOf(19) === -1) {
                        if (!value.inclassroom || !value.inclassroom.type)
                          return null;
                        const permIdx = window.app.state.permitions
                          .map((x) => x.id)
                          .indexOf(value.inclassroom.type);
                        if (permIdx === -1) return null;
                        permits =
                          window.app.state.permitions[permIdx].permissions;
                      } else {
                        permits = this.props.permission;
                      }

                      const courseName =
                        this.state.course.find((c) => c.id === value.course)
                          ?.name || "";

                      return (
                        <tr key={value.id} idc={value.id} className="tableList">
                          <td>{value.id}</td>
                          <td
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.props.history.push(
                                "/myclassroom/" + value.id
                              )
                            }
                          >
                            {value.name}
                          </td>
                          <td>{courseName}</td>
                          <td hidden={!showRest}>{value.idOnline}</td>
                          <td hidden={!showRest}>
                            <center>
                              {moment(value.openingDate, "YYYY-MM-DD").format(
                                "DD/MM/YYYY"
                              )}
                            </center>
                          </td>
                          <td hidden={!showRest}>
                            <center>
                              {moment(value.closingDate, "YYYY-MM-DD").format(
                                "DD/MM/YYYY"
                              )}
                            </center>
                          </td>
                          <td>
                            <center
                              id={`tooltipClassroom_${value.id}`}
                              style={{ fontWeight: "800" }}
                              className="animated fadeIn"
                              onMouseEnter={() => this.showTooltip(`tooltipClassroom_${value.id}`, value)}
                              onMouseLeave={this.hideTooltip}
                            >
                              {value.countParticipants}
                            </center>
                          </td>
                          {/* alterado para centralizar as ações da lista principal */}
                          <td className="text-center">
                            {permits.indexOf(18) !== -1 && (
                              <>
                                <Link
                                  to={
                                    "/classroom/dashboard/" + value.id + "/none"
                                  }
                                  id={`tt1_${value.id}`}
                                  className="table-action"
                                >
                                  <i className="fas fa-chart-pie" />
                                </Link>
                                <UncontrolledTooltip
                                  delay={0}
                                  target={`tt1_${value.id}`}
                                >
                                  {this.props.translate["progresso_da_turma"]}
                                </UncontrolledTooltip>
                              </>
                            )}
                            {permits.indexOf(17) !== -1 && (
                              <>
                                <a
                                  id={`tt2_${value.id}`}
                                  href="#"
                                  onClick={() =>
                                    this.addUserClassRoom(value.id)
                                  }
                                  className="table-action"
                                >
                                  <i className="fas fa-users" />
                                </a>
                                <UncontrolledTooltip
                                  delay={0}
                                  target={`tt2_${value.id}`}
                                >
                                  {this.props.translate["participantes"]}
                                </UncontrolledTooltip>

                                <a
                                  id={`tt2_dd_${value.id}`}
                                  href="#"
                                  onClick={() =>
                                    this.openModal("openModalTransfer", {
                                      transferID: value.id,
                                    })
                                  }
                                  className="table-action"
                                >
                                  <i className="fas fa-exchange-alt" />
                                </a>
                                <UncontrolledTooltip
                                  delay={0}
                                  target={`tt2_dd_${value.id}`}
                                >
                                  {
                                    this.props.translate[
                                    "transferir_participantes"
                                    ]
                                  }
                                </UncontrolledTooltip>
                              </>
                            )}
                            {permits.indexOf(15) !== -1 && (
                              <>
                                <a
                                  id={`tt3_${value.id}`}
                                  href="#"
                                  onClick={() => this.editClassRoom(value.id)}
                                  className="table-action"
                                >
                                  <i className="fas fa-pencil-alt" />
                                </a>
                                <UncontrolledTooltip
                                  delay={0}
                                  target={`tt3_${value.id}`}
                                >
                                  {this.props.translate["editar_turma"]}
                                </UncontrolledTooltip>
                              </>
                            )}
                            {permits.indexOf(16) !== -1 && (
                              <>
                                <a
                                  id={`tt4_${value.id}`}
                                  href="#"
                                  onClick={() => this.deleteClassRoom(value.id)}
                                  className="table-action"
                                >
                                  <i className="far fa-trash-alt" />
                                </a>
                                <UncontrolledTooltip
                                  delay={0}
                                  target={`tt4_${value.id}`}
                                >
                                  {this.props.translate["deletar_turma"]}
                                </UncontrolledTooltip>
                              </>
                            )}
                            <a
                              id={`tt_settings_${value.id}`}
                              href="#"
                              onClick={() => this.openGeneralSettings(value)}
                              className="table-action"
                            >
                              <i className="fas fa-cog" />
                            </a>
                            <UncontrolledTooltip
                              delay={0}
                              target={`tt_settings_${value.id}`}
                            >
                              {this.props.translate["configuracoes"] ||
                                "Configurações"}
                            </UncontrolledTooltip>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>

                {this.state.tooltipData && (
                  <Tooltip
                    autohide={false}
                    placement="right"
                    isOpen={this.state.tooltipOpen}
                    target={this.state.tooltipTarget}
                    toggle={this.hideTooltip}
                  >
                    <div style={{ maxWidth: "300px", textAlign: "left" }}>
                      <strong>
                        {this.props.translate["total_de_participantes"] || "Total de participantes:"}
                      </strong>{" "}
                      {this.state.tooltipData.countParticipants || 0}
                      <br />
                      <strong>
                        {this.props.translate["alunos_label"] || "Alunos:"}
                      </strong>{" "}
                      {this.state.tooltipData.countStudents || 0}
                      <br />
                      <strong>
                        {this.props.translate["instrutores_label"] || "Instrutores:"}
                      </strong>{" "}
                      {this.state.tooltipData.countTeachers || 0}
                      <br />
                      <strong>
                        {this.props.translate["administradores_label"] || "Administradores:"}
                      </strong>{" "}
                      {this.state.tooltipData.countAdmins || 0}
                      <br />
                      <strong>
                        {this.props.translate["units_label"] || "Units:"}
                      </strong>{" "}
                      {this.state.tooltipData.unitsCount ?? 0}
                      <br />
                      <strong>
                        {this.props.translate["ativos_label"] || "Ativos:"}
                      </strong>{" "}
                      {this.state.tooltipData.countActive || 0}
                      <br />
                      <strong>
                        {this.props.translate["inativos_label"] || "Inativos:"}
                      </strong>{" "}
                      {this.state.tooltipData.countInactive || 0}
                      <br />
                    </div>
                  </Tooltip>
                )}

                {classRooms.length === 0 &&
                  selectedCompany !== "" &&
                  loadClassroom && (
                    <center>
                      <h3 style={{ margin: "30px 0px" }}>
                        {this.props.translate["nenhuma_turma_foi_encontrada"]}
                      </h3>
                    </center>
                  )}
                {selectedCompany === "" &&
                  classRooms.length === 0 &&
                  loadClassroom && (
                    <center>
                      <h3 style={{ margin: "30px 0px" }}>
                        {
                          this.props.translate[
                          "voce_nao_tem_acesso_a_nenhum_unidade"
                          ]
                        }
                      </h3>
                    </center>
                  )}
                {!loadClassroom && (
                  <div
                    className="col-md-12"
                    style={{ marginTop: "40px", marginBottom: "30px" }}
                  >
                    <center>
                      <ClipLoader
                        sizeUnit={"px"}
                        size={60}
                        color={"#adb5bd"}
                        loading={true}
                      />
                    </center>
                  </div>
                )}
              </Card>
            </div>
          </Row>
        </Container>

        {/* Modal de criação/edição de turma */}
        {this.state.classRoomEditor && (
          <ClassRoomCreateModal
            isOpen={Boolean(this.state.classRoomEditor)}
            mode={this.state.classRoomEditor?.mode || "create"}
            classroom={this.state.classRoomEditor?.classroom || null}
            translate={this.props.translate}
            permissions={this.props.permission}
            companyId={selectedCompany}
            onClose={this.handleClassRoomModalClose}
            onSaved={this.handleClassRoomModalSaved}
          />
        )}

        {this.state.openModalTransfer && (
          <TransferModal
            isOpen={this.state.openModalTransfer}
            onClose={() => this.closeModal("openModalTransfer")}
            classroom={this.state.transferID}
            getClassRooms={() => this.getClassRooms()}
            classRooms={this.state.classRooms}
            setParentState={(data) => this.setState(data)}
            translate={this.props.translate}
            notify={this.notify}
          />
        )}

        {this.state.removalTarget && (
          <RemoveClassRoomModal
            isOpen={Boolean(this.state.removalTarget)}
            classroom={this.state.removalTarget}
            translate={this.props.translate}
            notify={this.notify}
            onClose={this.handleRemoveModalClose}
            onRemoved={this.handleClassRoomRemoved}
          />
        )}

        {this.state.addUserClassRoomModal && (
          <ParticipantsManageModal
            isOpen={Boolean(this.state.addUserClassRoomModal)}
            classroom={this.state.classRooms.find((c) => c.id === this.state.participantsTarget) || null}
            companyId={selectedCompany}
            translate={this.props.translate}
            notify={this.notify}
            onClose={() => this.closeModal("addUserClassRoomModal", { participantsTarget: null })}
            onParticipantsChanged={() => this.getClassRooms(selectedCompany)}
            permissionsCatalog={window.app?.state?.permitions || []}
            permission={this.props.permission}
          />
        )}

        {this.state.settingsModalOpen && (
          <SettingsModal
            isOpen={this.state.settingsModalOpen}
            classroom={this.state.settingsTarget}
            translate={this.props.translate}
            notify={this.notify}
            onClose={this.closeGeneralSettings}
          />
        )}


        {this.state.openModalImportClassRoom && (
          <ImportXlsxClassRoom
            getAllClassRoom={() => this.getAllClassRoom()}
            postClassRoom={this.postClassRoom}
            state={this.state}
            setState={(data) => this.setState(data)}
          />
        )}
      </React.Fragment>
    );
  }
}

export default connect((state) => ({
  languages: state.language,
  translate: state.translate,
  accesslevel: state.accesslevel,
  permission: state.permission,
  user: state.user,
}))(ListClassRoom);
